import { FlatActionList } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { useTranslation } from "../../../../../../utilities/i18n";
import { PaymentMethodFormValues } from "../../types";
import { Switch } from "react-native";

export interface EnabledFormInputProps {}

export const EnabledFormInput = ({}: EnabledFormInputProps) => {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<PaymentMethodFormValues>();
  return (
    <View>
      <FlatActionList
        items={[
          {
            key: "payment_method_enabled",
            title: t("form.payment_method_enabled.label"),
            subTitle: t("form.payment_method_enabled.description"),
            onPress: () => {},
            componentRight: () => (
              <Controller
                name="enabled"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <View>
                    <Switch
                      value={value}
                      onValueChange={() => {
                        onChange(!value);
                      }}
                    />
                  </View>
                )}
              />
            ),
          },
        ]}
      />
    </View>
  );
};
